import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { HttpClientModule } from '@angular/common/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};
import { SelectDropDownModule } from 'ngx-select-dropdown';

import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { deleteModalComponent } from './deleteModal/deleteModal.component';
import { uploadModalComponent } from './uploadModal/uploadModal.component';
import { exportModalComponent } from './exportModal/exportModal.component';
import { enterModalComponent } from './enterModal/enterModal.component';
import { TableModalComponent } from './TableModal/TableModal.component';
import { LocationModalComponent } from './locationModal/locationModal.component';

import { LoaderComponent } from './loader/loader.component';
import { VectorMapComponent1 } from './vector-map/vector-map.component';

import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { DxVectorMapModule, DxPieChartModule } from 'devextreme-angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// import { TableModalComponent } from "./TableModal/TableModal.component";
import { pageLoaderComponent } from './pageLoader/pageLoader.component';
import { blockModalComponent } from './blockModal/blockModal.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePickerComponent } from './date-picker/date-picker.component';
import { StarComponent } from './star/star.component';
import { ViewPhleboModalComponent } from './view-phlebo-modal/view-phlebo-modal.component';
import { FloatingChatComponent } from './floating-chat/floating-chat.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        CollapseModule.forRoot(),
        PerfectScrollbarModule,
        BsDropdownModule.forRoot(),
        DxVectorMapModule,
        DxPieChartModule,
        BsDatepickerModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgbModule,
        SelectDropDownModule

    ],
    declarations: [
        FooterComponent,
        VectorMapComponent1,
        NavbarComponent,
        SidebarComponent,
        deleteModalComponent,
        uploadModalComponent,
        TableModalComponent,
        exportModalComponent,
        LoaderComponent,
        pageLoaderComponent,
        blockModalComponent,
        StarComponent,
        enterModalComponent,
        LocationModalComponent,
        DatePickerComponent,
        ViewPhleboModalComponent,
        FloatingChatComponent
    ],
    exports: [
        FooterComponent,
        VectorMapComponent1,
        NavbarComponent,
        LoaderComponent,
        pageLoaderComponent,
        deleteModalComponent,
        uploadModalComponent,
        TableModalComponent,
        exportModalComponent,
        SidebarComponent,
        blockModalComponent,
        enterModalComponent,
        LocationModalComponent,
        DatePickerComponent,
        StarComponent,
        FloatingChatComponent
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ]
})
export class ComponentsModule { }
